import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Chevron } from './UiIcons';
import { ssColorCyan } from '../constants/style-constants';

const AccordionControl = ({
  id, isActive, onClick, children,
}) => (
  <div
    className="ss_accordion-control"
    tabIndex={0}
    role="button"
    id={id}
    aria-expanded={isActive}
    aria-controls={`body-${id}`}
    onClick={() => onClick(!isActive)}
    onKeyPress={(event) => {
      if (
        event.key === ' '
        || event.key === 'Enter'
        || event.key === 'Spacebar'
      ) {
        onClick(!isActive);
      }
    }}
  >
    {children}
    <span className="ss_accordion-control__icon">
      <Chevron
        width={18}
        height={30}
        color={ssColorCyan}
        className="ss_vertical-align--middle"
      />
    </span>
  </div>
);
AccordionControl.propTypes = {
  isActive: PropTypes.bool.isRequired,
  id: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func.isRequired,
};

const AccordionBody = ({
  id, labelledBy, children, isActive,
}) => (
  <div role="region" id={id} aria-labelledby={labelledBy} hidden={!isActive}>
    {children}
  </div>
);
AccordionBody.propTypes = {
  isActive: PropTypes.bool.isRequired,
  id: PropTypes.string.isRequired,
  labelledBy: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

const AccordionGroup = ({
  isActiveByDefault, id, controlContent, bodyContent,
}) => {
  const [isActive, setIsActive] = useState(isActiveByDefault);

  return (
    <div className="ss_accordion-group">
      <AccordionControl
        parentId={id}
        id={id}
        isActive={isActive}
        onClick={setIsActive}
      >
        {controlContent}
      </AccordionControl>
      <AccordionBody labelledBy={id} id={`body-${id}`} isActive={isActive}>
        {bodyContent}
      </AccordionBody>
    </div>
  );
};
AccordionGroup.defaultProps = {
  isActiveByDefault: false,
};

AccordionGroup.propTypes = {
  id: PropTypes.string.isRequired,
  controlContent: PropTypes.node.isRequired,
  bodyContent: PropTypes.node.isRequired,
  isActiveByDefault: PropTypes.bool,
};

export default AccordionGroup;
